<div class="form-button-container fx-row fx-gap-xs">
  @if (showCancel) {
    <button class="form-button cancel-button fx-1-1-0" mat-stroked-button type="button" [ngClass]="cancelClass" (click)="cancel.emit()">{{cancelText}}</button>
  }
  @if (showSave) {
    <button class="form-button save-button fx-1-1-0" color="primary" mat-stroked-button type="submit" [disabled]="saveDisabled" [ngClass]="saveClass" (click)="save.emit()">{{saveText}}</button>
  }
</div>
